<template>
    <div class="flex-column">
        <h4
            v-if="typeof filter.label === 'object' || typeof filter.label === 'array'"
            v-html="filter.label[0]"
        ></h4>
        <h4 v-else v-html="filter.label"></h4>

        <form class="flex-column" @submit.prevent="applyFilter(false)">
            <component
                :is="filter.component"
                :filter="filter"
                class="fs-3 filter-subcontainer ovx-hidden"
                @filter:update="updateData"
            />

            <div class="acenter mt-3">
                <CompassButton
                    :label="$t.__('listing.filters.ListingFilter.apply_filter')"
                    submit
                    :disabled="cannotSubmit"
                />
                <CompassButton
                    v-if="!filter.active"
                    :label="$t.__('listing.filters.ListingFilter.add_another_filter')"
                    type="secondary"
                    size="small"
                    leftIcon="plus"
                    class="mt-3"
                    @click.prevent="applyFilter(true)"
                />
            </div>
        </form>
    </div>
</template>

<script>
import CheckboxFilter from './CheckboxFilter.vue';
import Checkbox2lvlFilter from './Checkbox2lvlFilter.vue';
import RadioFilter from './RadioFilter.vue';
import AutocompleteFilter from './AutocompleteFilter.vue';
import TextFilter from './TextFilter.vue';
import TimeFilter from './TimeFilter.vue';
import DateFilter from './DateFilter.vue';
import TagFilter from './TagFilter.vue';
import RangeFilter from './RangeFilter.vue';
import BooleanFilter from './BooleanFilter.vue';
import LocationFilter from './LocationFilter.vue';
import RgpdFilter from './RgpdFilter.vue';
import SelectFilter from './SelectFilter.vue';
import ContactTypeFilter from './ContactTypeFilter.vue';
import RecursivecheckboxFilter from './RecursiveCheckboxFilter.vue';
import WithWithoutTypeStatusesFilter from './WithWithoutTypeStatusesFilter.vue';

import { FilterTranslator } from './FilterTranslator';

export default {
    components: {
        CheckboxFilter,
        Checkbox2lvlFilter,
        TextFilter,
        TimeFilter,
        DateFilter,
        TagFilter,
        RangeFilter,
        BooleanFilter,
        LocationFilter,
        AutocompleteFilter,
        RgpdFilter,
        ContactTypeFilter,
        RadioFilter,
        SelectFilter,
        RecursivecheckboxFilter,
        WithWithoutTypeStatusesFilter,
    },
    props: {
        filter: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            filterData: false,
        };
    },

    computed: {
        cannotSubmit() {
            return !(this.filterData && this.filterData !== this.filter.data);
        },
    },

    methods: {
        updateData(data) {
            this.filterData = data;
        },

        applyFilter(addNewFlag = false) {
            const payload = {
                filter: this.filter,
                addNew: addNewFlag,
            };

            payload.filter.data = this.filterData;
            const translator = new FilterTranslator(payload.filter);
            payload.filter.translation = translator.translate();
            payload.filter.pending = true;

            if (
                payload?.filter?.data?.subChoices &&
                payload.filter.data.subChoices.length === 0 &&
                !_.isNil(payload.filter.data.subChoices[0])
            ) {
                payload.filter.data.subChoices = _.keys(
                    payload.filter.inputs.type.options[payload.filter.data.choice].choices,
                );
            }
            this.$emit('filter:apply', payload);
        },
    },
};
</script>

<style scoped lang="scss">
.filter-subcontainer {
    max-height: 100%;
    display: contents;
}
</style>
